
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { moneyFormatter } from '../../../utils/helpers'
import { Typeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import { DropdownButton, ButtonToolbar, Button, MenuItem, FormControl, OverlayTrigger, Tooltip } from 'react-bootstrap'
// import ReactPaginate from 'react-paginate'
import EditableTD from './EditableTD'
import SupplierPageModal from '../../po/SupplierPageModal'
import WorkdocStore from '../../../stores/WorkdocStore'
import './priceCompare.css'


// const createMockShopList = () => (
//   new Array(50).fill(null).map((value, index) => {
//     const minPrice = 1
//     const maxPrice = 100000
//     const getRandomInt = (min, max) => {
//       min = Math.ceil(min);
//       max = Math.floor(max);
//       return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
//     }

//     return Object.assign({},
//       {
//         shopId: 500 + index,
//         shopName: Math.random().toString(36).substr(2, 5),
//         originalPrice: getRandomInt(minPrice, maxPrice),
//         similarPrice: getRandomInt(minPrice, maxPrice),
//         oldPartPrice: getRandomInt(minPrice, maxPrice),
//       })
//   })
// )

// const originalShopList = [
//   {
//     shopId: 1,
//     shopName: 'ร้านศรีสยาม',
//     originalPrice: 1000,
//     similarPrice: 800,
//     oldPartPrice: 600,
//   },
//   {
//     shopId: 2,
//     shopName: 'ร้านจิตต์',
//     originalPrice: 1000,
//     similarPrice: 800,
//     oldPartPrice: 600,
//   }
// ]

// let mockData = {
//   partList: [
//     {
//       part_itemnum: '1',
//       detail: 'กันชนหน้า',
//       quantity: 2,
//       unitPrice: 0,
//       selectedShopId: '',
//       selectedPrice: '',
//       shopList: createMockShopList()
//       // shopList: []
//     },
//     {
//       part_itemnum: '2',
//       detail: 'พวงมาลัย',
//       quantity: 2,
//       unitPrice: 0,
//       selectedShopId: '',
//       selectedPrice: '',
//       shopList: createMockShopList()
//       // shopList: []
//     }
//   ]
// }

class PriceCompare extends Component {
  constructor(...args) {
    super(...args)
    this.state = {
      data: {},
      showModal: false
    }
  }

  componentDidMount() {
    this.loadPriceCompare()
  }

  loadPriceCompare() {
    let { workNo } = this.props
    let that = this
    WorkdocStore.loadWorkdocPriceCompare(workNo, function (result) {
      let data = result.data
      data.partList = data.partList.map((item,index)=>{
        item = Object.assign({approval_price:''}, item)
        return item
      })
      that.setState({ data: data })
    }, function () {

    })
  }

  renderFreezeFooter() {
    if (this.state.data.partList === null || typeof this.state.data.partList === 'undefined')
      return

    const totalUnitPrice = this.state.data.partList.reduce((total, partItem) => (
      total + partItem.unitPrice * partItem.quantity * 1
    ), 0)

    return (
      <tr>
        <th className='text-center' colSpan={4}>ยอดสั่งซื้อ</th>
        <th className='text-center bg-yellow'>{moneyFormatter.format(totalUnitPrice)}</th>
      </tr>
    )
  }

  updateUnitPrice(part_itemnum, newUnitPrice) {
    const newPartList = this.state.data.partList.map((partItem) => {
      if (partItem.part_itemnum === part_itemnum)
        partItem.unitPrice = newUnitPrice
      return partItem
    })

    this.setState((prevState) => {
      prevState.data.partList = newPartList
      return {
        data: prevState.data
      }
    })
  }

  renderMenuItemChildren(result, props) {
    // console.log(props)
    return (
      <div>{result.label}</div>
    )
  }

  onUnitPriceInputChange(partItem, inputValue) {
    if (isNaN(inputValue)) {
      // console.log(inputValue)
      const refName = 'unitPrice:' + partItem.part_itemnum
      this[refName].getInstance().clear()
      // this.updateUnitPrice(partItem.part_itemnum, 0)
    }
  }

  onUnitPriceTypeAheadBlur(partItem, e) {
    // console.log('onUnitPriceTypeAheadBlur', e.target)
    if (e.target.value * 1 !== partItem.unitPrice) {
      this.updateUnitPrice(partItem.part_itemnum, e.target.value * 1)
      // this.updateUnitPrice(partItem.part_itemnum, partItem.unitPrice * 1)
    }

    // this[partItem.part_itemnum].getInstance()._updateText(partItem.unitPrice)
    // console.log(this[partItem.part_itemnum].getInstance())
  }

  onUnitPriceSelectChange(part_itemnum, selectedItems) {
    if (selectedItems.length === 0) return
    if (isNaN(selectedItems[0].id))
      this.updateUnitPrice(part_itemnum, 0)
    else
      this.updateUnitPrice(part_itemnum, selectedItems[0].id * 1)
  }


  renderUnitPrice(partItem) {
    const percents = [0.15, 0.20, 0.30]
    const selectedShop = partItem.shopList.filter((shop) => shop.shopId === partItem.selectedShopId)
    const price =
      partItem.selectedPrice !== '' && selectedShop.length > 0
        ? selectedShop[0][partItem.selectedPrice]
        : partItem.unitPrice

    const prices =
      partItem.selectedPrice !== ''
        ? percents.map((percent) => Math.round(price + price * percent))
        : []
    const options = prices.map((thePrice, i) => (
      {
        id: thePrice + '',
        label: moneyFormatter.format(thePrice) + '(' + percents[i] * 100 + '%)'
      }
    ))

    const refName = 'unitPrice:' + partItem.part_itemnum
    return (
      <Typeahead
        ref={(ta) => { this[refName] = ta }}
        selected={[partItem.unitPrice + '']}
        style={{ textAlign: 'right' }}
        bsSize="sm"
        allowNew={true}
        newSelectionPrefix="ราคา:"
        emptyLabel="พิมพ์ราคาใหม่"
        labelKey={'id'}
        // placeholder={partItem.unitPrice + ''}
        filterBy={(option, text) => {
          return option.id
        }}
        options={options}
        onChange={this.onUnitPriceSelectChange.bind(this, partItem.part_itemnum)}
        onBlur={this.onUnitPriceTypeAheadBlur.bind(this, partItem)}
        renderMenuItemChildren={this.renderMenuItemChildren.bind(this)}
        onInputChange={this.onUnitPriceInputChange.bind(this, partItem)}

      />
    )
  }

  /* onQuantityChange(selectedPartItem, e) {
    const newPartList = this.state.data.partList.map((partItem) => {
      if (partItem.part_itemnum === selectedPartItem.part_itemnum) {
        partItem.quantity = e.target.value * 1
        return partItem
      }
      return partItem
    })
  
    this.setState((prevState) => {
      prevState.data.partList = newPartList
      return {
        data: prevState.data
      }
    })
  } */

  updateQuantity(selectedPartItem, newQuantity) {
    const newPartList = this.state.data.partList.map((partItem) => {
      if (partItem.part_itemnum === selectedPartItem.part_itemnum) {
        partItem.quantity = isNaN(newQuantity) ? 0 : newQuantity
        return partItem
      }
      return partItem
    })

    this.setState((prevState) => {
      prevState.data.partList = newPartList
      return {
        data: prevState.data
      }
    })
  }

  onNewQuantityChange(selectedPartItem, selectedItems) {
    if (selectedItems.length === 0) return
    const newQuantity = selectedItems[0].id
    this.updateQuantity(selectedPartItem, newQuantity)
  }

  updateApprovalPrice(selectedPartItem, newApprovalPrice) {
    const newPartList = this.state.data.partList.map((partItem) => {
      if (partItem.part_itemnum === selectedPartItem.part_itemnum) {
        partItem.approval_price = newApprovalPrice
        return partItem
      }
      return partItem
    })

    this.setState((prevState) => {
      prevState.data.partList = newPartList
      return {
        data: prevState.data
      }
    })
  }

  onApprovalPriceChange(selectedPartItem,e) {
    let newApprovalPrice = e.target.value
    this.updateApprovalPrice(selectedPartItem,newApprovalPrice)
  }

  onQuantityTypeAheadBlur(selectedPartItem, e) {
    const newQuantity = e.target.value
    this.updateQuantity(selectedPartItem, newQuantity)
  }

  renderNewQuantity(partItem) {
    const prices = new Array(10).fill(null).map((val, index) => index + 1)
    const options = prices.map((thePrice, i) => (
      { id: thePrice + '', label: thePrice + '' }
    ))

    return (
      <Typeahead
        selected={[partItem.quantity + '']}
        // ref={(ta) => { this[refName] = ta }}
        // style={{ textAlign: 'right' }}
        bsSize="sm"
        allowNew={true}
        newSelectionPrefix="จำนวน:"
        // emptyLabel="จำนวน"
        labelKey={'id'}
        // placeholder={partItem.unitPrice + ''}
        filterBy={(option, text) => {
          return option
        }}
        options={options}
        onChange={this.onNewQuantityChange.bind(this, partItem)}
        onBlur={this.onQuantityTypeAheadBlur.bind(this, partItem)}
      // renderMenuItemChildren={this.renderMenuItemChildren.bind(this)}
      />
    )
  }

  renderApprovalPrice(partItem) {
    return(
      <FormControl
        className='text-right'
        style={{height:'30px'}}
        onChange={this.onApprovalPriceChange.bind(this, partItem)}
        value={partItem.approval_price}
      />
    )
  }

  /* renderQuantity(partItem) {
    return (
      <FormControl
        value={partItem.quantity}
        bsSize="sm"
        className='text-center'
        onChange={this.onQuantityChange.bind(this, partItem)}
      />
    )
  } */

  renderFreezedBody() {
    if (typeof this.state.data.partList === 'undefined') return
    // const tdStyle = { maxheight: '30px' }
    return( 
      this.state.data.partList.map((partItem, i) => {
        let tooltip = (<div />)
        tooltip = (
          <OverlayTrigger
            key={'top'}
            placement={'top'}
            overlay={
              <Tooltip id='tooltip-top'>
                {partItem.detail}
              </Tooltip>
            }
          >
            <div style={{whiteSpace:'nowrap',width:'200px',overflow:'hidden',textOverflow:'ellipsis'}}>
              {partItem.detail}
            </div>  
          </OverlayTrigger>
        )
        return(
          <tr key={i}>
            <td className='text-center' style={{ width: '80px' }}>{i + 1}</td>
            <td>
              {tooltip}
            </td>
            <td style={{ width: '80px' }}>{this.renderNewQuantity(partItem)}</td>
            <td style={{ width: '120px' }}>{this.renderUnitPrice(partItem)}</td>
            <td style={{ width: '120px' }}>{this.renderApprovalPrice(partItem)}</td>
          </tr>
        )  
      })  
    )
  }

  renderFreezedTable() {
    const titles = [
      {
        title: 'ลำดับ',
        style: { width: '20px', maxWidth: '20px' },
        className: 'text-center'
      },
      {
        title: 'รายการอะไหล่',
        style: { height: '86px', width: '200px', minWidth: '200px' },
        className: 'text-center'
      },
      {
        title: 'จำนวน',
        style: { width: '20px' },
        className: 'text-center'
      },
      {
        title: 'ค่าอะไหล่',
        style: { width: '100px' },
        className: 'text-center'
      },
      {
        title: 'ราคาอนุมัติ',
        style: { width: '100px' },
        className: 'text-center'
      }
    ]

    // 78px from value of two <thead> in ScrollableTable
    // const detailStyle = {
    //   height: '78px'
    //   // minWidth: '250px'
    // }
    const header = titles.map((eachTitle, tid) => (
      <th
        key={tid}
        className={eachTitle.className}
        style={eachTitle.style}
      >
        {eachTitle.title}
      </th>
    ))
    return (
      <table className='table table-responsive table-hover table-bordered-solid freezed-table'>
        <thead>
          <tr>
            {header}
          </tr>
        </thead>
        <tbody>
          {this.renderFreezedBody()}
        </tbody>
        <tfoot>
          {this.renderFreezeFooter()}
        </tfoot>
      </table>
    )
  }

  // onUnitPriceInputTextEnter(part_itemnum, shopId, priceType, bf, newPrice) {
  //   const newPartList = this.state.data.partList.map((partItem) => {
  //     if ((partItem.part_itemnum === part_itemnum&&partItem.bf_work_damage_id === bf)||(partItem.bf_work_damage_id === bf)) {
  //       partItem.shopList.forEach((shop) => {
  //         if (shop.shopId === shopId)
  //           shop[priceType] = newPrice * 1
  //       })
  //     }
  //     return partItem
  //   })
  //   this.setState((prevState) => {
  //     prevState.data.partList = newPartList
  //     return {
  //       data: prevState.data
  //     }
  //   })
  // }

  onUnitPriceInputTextEnter(part_itemnum, shopId, priceType, bf, seq, newPrice) {
    const newPartList = this.state.data.partList.map((partItem) => {
      if (
        (partItem.part_itemnum===''&&part_itemnum===''&&partItem.bf_work_damage_id===''&&bf===''&&seq===partItem.seq)||
        ((partItem.part_itemnum!==''&&part_itemnum!==''&&partItem.bf_work_damage_id!==''&&bf!=='')&&((partItem.part_itemnum===part_itemnum&&partItem.bf_work_damage_id===bf)||(partItem.bf_work_damage_id===bf)))) {
        partItem.shopList.forEach((shop) => {
          if (shop.shopId === shopId)
            shop[priceType] = newPrice * 1
        })
      }
      return partItem
    })
    this.setState((prevState) => {
      prevState.data.partList = newPartList
      return {
        data: prevState.data
      }
    })
  }

  // updatePartList(part_itemnum, shopId, priceType, bf) {
  //   // const currentData = JSON.parse(JSON.stringify(this.state.data))
  //   const newPartList = this.state.data.partList.map((partItem) => {
  //     // if click on selected price
  //     if (
  //       (partItem.part_itemnum === part_itemnum && partItem.selectedShopId === shopId && partItem.selectedPrice === priceType && partItem.bf_work_damage_id === bf)
  //       ||
  //       (partItem.selectedShopId === shopId && partItem.selectedPrice === priceType && partItem.bf_work_damage_id === bf)
  //     ) {
  //       partItem.selectedPrice = ''
  //       partItem.selectedShopId = ''
  //       return partItem
  //     }

  //     // click on different one
  //     if ((partItem.part_itemnum === part_itemnum && partItem.bf_work_damage_id === bf) || (partItem.bf_work_damage_id === bf)) {
  //       partItem.selectedShopId = shopId
  //       partItem.selectedPrice = priceType
  //     }
  //     return partItem
  //   })

  //   this.setState((prevState) => {
  //     prevState.data.partList = newPartList
  //     return {
  //       data: prevState.data
  //     }
  //   })
  // }

  updatePartList(part_itemnum, shopId, priceType, bf, seq) {
    // const currentData = JSON.parse(JSON.stringify(this.state.data))
    const newPartList = this.state.data.partList.map((partItem) => {
      // if click on selected price
      if (
        (seq===partItem.seq&&partItem.part_itemnum===''&&part_itemnum===''&&partItem.bf_work_damage_id===''&&bf===''&&partItem.selectedShopId === shopId && partItem.selectedPrice === priceType)
        ||
        ((partItem.part_itemnum!==''&&part_itemnum!==''&&partItem.bf_work_damage_id!==''&&bf!=='')&&((partItem.part_itemnum === part_itemnum && partItem.selectedShopId === shopId && partItem.selectedPrice === priceType && partItem.bf_work_damage_id === bf)
        ||
        (partItem.selectedShopId === shopId && partItem.selectedPrice === priceType && partItem.bf_work_damage_id === bf)))
      ) {
        partItem.selectedPrice = ''
        partItem.selectedShopId = ''
        return partItem
      }
      
      // click on different one
      if (
        (seq===partItem.seq&&partItem.part_itemnum===''&&part_itemnum===''&&partItem.bf_work_damage_id===''&&bf==='')
        ||
        ((partItem.part_itemnum!==''&&part_itemnum!==''&&partItem.bf_work_damage_id!==''&&bf!=='')&&((partItem.part_itemnum === part_itemnum && partItem.bf_work_damage_id === bf) || (partItem.bf_work_damage_id === bf)))
      ) {
        partItem.selectedShopId = shopId
        partItem.selectedPrice = priceType
      }
      return partItem
    })

    this.setState((prevState) => {
      prevState.data.itemlist = newPartList
      return {
        data: prevState.data
      }
    })
  }

  // onEditableTDClick(part_itemnum, shopId, priceType, bf) {
  //   this.updatePartList(part_itemnum, shopId, priceType, bf)
  // }

  onEditableTDClick(itemnum, shopId, priceType, bf, seq) {
    this.updatePartList(itemnum, shopId, priceType, bf, seq)
  }

  renderPartItem() {
    const priceColumns = ['similarPrice', 'originalPrice', 'oldPartPrice']

    return this.state.data.partList.map((partItem, pid) => {
      const tds = partItem.shopList.map((shop, sid) => (
        priceColumns.map((priceType, cid) => {
          const selected = (partItem.selectedShopId === shop.shopId && partItem.selectedPrice === priceType)
          const tdKey = pid * 10 + cid
          return (
            <EditableTD
              key={tdKey}
              value={shop[priceType]}
              selected={selected}
              tdStyle={{ minWidth: '90px', maxWidth: '90px' }}
              textInputStyle={{ textAlign: 'center', height: '30px' }}
              textDivStyle={{ textAlign: 'center', height: '30px', lineHeight: '30px', padding: '0' }}
              className={selected ? 'bg-yellow' : ''}
              onInputTextEnter={this.onUnitPriceInputTextEnter.bind(this, partItem.part_itemnum, shop.shopId, priceType, partItem.bf_work_damage_id, partItem.seq)}
              onInputTextBlur={this.onUnitPriceInputTextEnter.bind(this, partItem.part_itemnum, shop.shopId, priceType, partItem.bf_work_damage_id, partItem.seq)}
              onClick={this.onEditableTDClick.bind(this, partItem.part_itemnum, shop.shopId, priceType, partItem.bf_work_damage_id, partItem.seq)}
              // onInputTextBlur={this.onUnitPriceInputTextEnter.bind(this, partItem.part_itemnum, shop.shopId, priceType)}
              // onDoubleClick={this.onEditableTDDoubleClick.bind(this, partItem.part_itemnum, partItem.selectedShopId, partItem.selectedPrice)}
            />
          )
        })
      ))

      return <tr key={pid}>{tds}</tr>
    })
  }

  renderScrollableFooter() {
    const totalShopPrice =
      this.state.data.partList.reduce((sumPriceShop, partItem) => {
        const selectedPriceOfShops =
          partItem.shopList.map((shop) => {
            if (shop.shopId === partItem.selectedShopId)
              return shop[partItem.selectedPrice]
            return 0
          })

        if (sumPriceShop.length === 0)
          return sumPriceShop.concat(selectedPriceOfShops)
        return sumPriceShop.map((eachSum, i) => (
          eachSum + selectedPriceOfShops[i]
        ))
      }, [])

    const tds =
      totalShopPrice.map((price, i) => (
        <th
          key={i}
          colSpan={3}
          className='text-center bg-yellow'
        >
          {moneyFormatter.format(price)}
        </th>
      ))

    return <tr>{tds}</tr>
  }

  onRemoveShopClick(shopIdToRemove) {
    const newPartList = this.state.data.partList.map((partItem) => {
      const newPartItem = JSON.parse(JSON.stringify(partItem))
      newPartItem.selectedPrice = ''
      newPartItem.selectedShopId = ''
      newPartItem.shopList = partItem.shopList.filter((shop) => shop.shopId !== shopIdToRemove)
      return newPartItem
    })

    this.setState((prevState) => {
      const newData = JSON.parse(JSON.stringify(prevState.data))
      newData.partList = newPartList
      return {
        data: newData
      }
    })
  }

  renderScrollableTable() {
    if (typeof this.state.data.partList === 'undefined') return
    const priceTitles = ['เทียบ', 'แท้', 'เก่า']
    const shopHeaders = this.state.data.partList[0].shopList.map((shop, i) => (
      <th
        key={i}
        className='text-center'
        colSpan={priceTitles.length}
      >
        {shop.shopName}
        <span
          className='remove-shop pull-right'
          onClick={this.onRemoveShopClick.bind(this, shop.shopId)}
        >
          <FontAwesome
            name='close'
            style={{ color: 'LightBlue' }}
          />
        </span>
      </th>
    ))
    const priceHeaders = this.state.data.partList[0].shopList.map((shop, sid) => {
      return priceTitles.map((title, tid) => (
        <th
          key={sid * 10 + tid}
          className='text-center'
          style={{minWidth:'100px'}}
        >
          {title}
        </th>
      ))
    })

    return (
      <table className='table table-responsive table-hover table-bordered-solid freezed-table'>
        <thead>
          <tr>
            {shopHeaders}
          </tr>
          <tr>
            {priceHeaders}
          </tr>
        </thead>
        <tbody>
          {this.renderPartItem()}
        </tbody>
        <tfoot>
          {this.renderScrollableFooter()}
        </tfoot>
      </table>
    )
  }

  renderTable() {
    return (
      <div>
        <div className='col-lg-5 col-md-12 padding-none'>
          {this.renderFreezedTable()}
        </div>
        <div className='col-lg-7 col-md-12 padding-none display-overflow'>
          {this.renderScrollableTable()}
        </div>
      </div>
    )
  }

  onMenuSelect(eventKey) {
    // eventKey = shopId
  }

  onAddShopClick(e) {
    this.setState({
      showModal: true
    })
  }

  onSupplierPageSelect(item) {
    if (this.state.data.partList.length === 0) return

    const newPartList = this.state.data.partList.map((partItem) => {
      const shopExisted = partItem.shopList.filter((shop) => shop.shopId === item.shop_id).length > 0
      if (shopExisted) return partItem

      // if it's new shop, add into shopList
      const newShopList = partItem.shopList.concat({
        shopId: item.shop_id,
        shopName: item.name,
        originalPrice: 0,
        similarPrice: 0,
        oldPartPrice: 0
      })
      const newPartItem = JSON.parse(JSON.stringify(partItem))
      newPartItem.shopList = newShopList
      return newPartItem
    })

    if (this.state.data.partList[0].shopList.length === newPartList[0].shopList.length) return
    this.setState((prevState) => {
      const newData = JSON.parse(JSON.stringify(prevState.data))
      newData.partList = newPartList
      return {
        data: newData
      }
    })
  }

  onSaveClick(){
    let {workNo} = this.props
    let {data} = this.state
    let that = this
    WorkdocStore.savePriceCompmare(workNo,data,function(result){
      if(that.props.onSave!==undefined){
        that.props.onSave(result)
      }
    },function(){

    })
  }

  onCloseClick(){
    if(this.props.onClose!==undefined){
      this.props.onClose()
    }
  }

  renderToolbar() {
    if (typeof this.state.data.partList === 'undefined') return
    const shopMenu = this.state.data.partList[0].shopList.map((shop, i) => (
      <MenuItem key={shop.shopId} eventKey={shop.shopId}>
        {shop.shopName}
      </MenuItem>
    ))
    const title = (<span><FontAwesome name='shopping-cart' /> สร้างรายการสั่งซื้อ</span>)
    return (
      <ButtonToolbar >
        <Button
          bsStyle="primary"
          onClick={this.onAddShopClick.bind(this)}
        >
          <FontAwesome name='plus' /> เพิ่มร้าน
        </Button>
        {/* <Dropdown id="create-purchase" pullRight onSelect={this.onMenuSelect.bind(this)}>
          <Button bsStyle="primary">
            <FontAwesome name='shopping-cart' /> สร้างรายการสั่งซื้อ
          </Button>
          <Dropdown.Toggle bsStyle="primary" />
          <Dropdown.Menu className="super-colors">
            {shopMenu}
          </Dropdown.Menu>
        </Dropdown> */}
        <DropdownButton disabled={shopMenu.length===0?true:false} bsStyle={'primary'} title={title} id={'create-purchase'} onSelect={this.onMenuSelect.bind(this)}>
          {shopMenu}
        </DropdownButton>
      </ButtonToolbar>
    )
  }

  render() {
    const titile = 'เปรียบเทียบราคาอะไหล่'
    return (
      <Box loading={this.state.loading}>
        <Box.Header border={true}>
          <Box.Title>{titile}</Box.Title>
          <Box.Tools className='pull-right'>
            {this.renderToolbar()}
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          <div className='price-compare'>
            {this.renderTable()}
          </div>
          <SupplierPageModal
            show={this.state.showModal}
            showNew={true}
            onHide={() => { this.setState({ showModal: false }) }}
            onSelect={this.onSupplierPageSelect.bind(this)}
          />
        </Box.Body>
        <Box.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save'/> บันทึก</Button>
            <Button bsStyle='default' onClick={this.onCloseClick.bind(this)}><FontAwesome name='close'/> ปิดใบงาน</Button>
          </ButtonToolbar>
        </Box.Footer>
      </Box>
    )
  }
}

export default PriceCompare



// WEBPACK FOOTER //
// ./src/view/workdoc/pricecompare/PriceCompare.js